import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { LuCalendar as Calendar, LuUser as User, LuTreePine, LuFerrisWheel, LuUsers } from 'react-icons/lu';
import SocialShareBar from './SocialShareBar';
import ProjectDetails from './ProjectDetails';
import logo from '../../assets/logo.png';
import imagineParc from '../../assets/plamanul-verde.jpeg';

const ProjectCard = () => {
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f3f4f6 0%, #e3e6ed 100%)",
      position: "relative",
      overflow: "hidden"
    }}>

      {/* Header Section */}
      <div style={{ position: "relative" }}>
        {/* Hero Image */}
        <div style={{
          height: 384,
          background: "linear-gradient(90deg, #143685 0%, #1e3a8a 100%)",
          position: "relative",
          overflow: "hidden"
        }}>
          <img
            src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=2000&q=80"
            alt="Plămânul Verde al Orașului"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: 0.3,
              position: "absolute",
              top: 0,
              left: 0
            }}
          />
          <div style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(90deg, rgba(20,54,133,0.8) 0%, rgba(30,58,138,0.6) 100%)"
          }}></div>

          {/* Hero Content */}
          <div style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <div className="text-center text-white mx-auto px-3" style={{ maxWidth: 900 }}>
              <div
                className="d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill mb-4"
                style={{
                  background: "rgba(255,255,255,0.10)",
                  backdropFilter: "blur(3px)"
                }}
              >
                <LuTreePine color="#FFC72C" size={24} />
                <span className="fw-semibold">Plămânul Verde al Orașului</span>
              </div>
              <h1 className="fw-bold mb-4" style={{ fontSize: "2.8rem", lineHeight: 1.1 }}>
                Plămânul Verde al Orașului
              </h1>
              <p className="lead opacity-90 mx-auto" style={{ maxWidth: 700 }}>
              PRDP propune parcuri urbane multifuncționale ce creează locuri de muncă, sprijină familiile, atrage turiști și susține economia locală, pentru un oraș mai curat și sustenabil.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Social Share Bar */}
      <SocialShareBar />

      {/* Main Content */}
      <Container className="py-5">
      <Row className="justify-content-center mb-5">
        <Col lg={10}>
          <Card className="shadow rounded-4 p-4 border-0" style={{ background: "#f8fafc" }}>
            <div className="text-center mb-5">
              <h2 className="fw-bold mb-3" style={{ color: "#143685" }}>Obiective Strategice</h2>
              <div
                style={{
                  width: 96,
                  height: 4,
                  backgroundColor: "#FFC72C",
                  margin: "0px auto 20px",
                  borderRadius: 2
                }}
              ></div>
            </div>
            <Row>
              <Col md={4} className="mb-3 mb-md-0">
                <Card className="border-0 shadow-sm rounded-3 text-center h-100" style={{ background: "#f5f7fa" }}>
                  <div
                    className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{
                      width: 64,
                      height: 64,
                      background: "#FFC72C",
                      borderRadius: "50%"
                    }}
                  >
                    <LuUsers color="#143685" size={28} />
                  </div>
                  <h5 className="fw-semibold" style={{ color: "#143685" }}>Locuri de muncă & comunitate</h5>
                  <p className="text-secondary small mb-3">
                    Crearea a peste 300 de locuri de muncă și sprijinirea familiilor prin facilități dedicate.
                  </p>
                </Card>
              </Col>
              <Col md={4} className="mb-3 mb-md-0">
                <Card className="border-0 shadow-sm rounded-3 text-center h-100" style={{ background: "#f5f7fa" }}>
                  <div
                    className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{
                      width: 64,
                      height: 64,
                      background: "#FFC72C",
                      borderRadius: "50%"
                    }}
                  >
                    <LuFerrisWheel color="#143685" size={28} />
                  </div>
                  <h5 className="fw-semibold" style={{ color: "#143685" }}>Turism & atractivitate</h5>
                  <p className="text-secondary small mb-3">
                    Atracții tematice (ex. roată panoramică) și evenimente pentru revitalizarea turismului și economiei locale.
                  </p>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="border-0 shadow-sm rounded-3 text-center h-100" style={{ background: "#f5f7fa" }}>
                  <div
                    className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{
                      width: 64,
                      height: 64,
                      background: "#FFC72C",
                      borderRadius: "50%"
                    }}
                  >
                    <LuTreePine color="#143685" size={28} />
                  </div>
                  <h5 className="fw-semibold" style={{ color: "#143685" }}>Verde & sustenabilitate</h5>
                  <p className="text-secondary small mb-3">
                    Crearea unui oraș mai curat și mai sănătos, cu spații verzi extinse și reducerea poluării.
                  </p>
                </Card>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

        <Row className="justify-content-center mb-5">
          <Col lg={10}>
            <img
              src={imagineParc}
              alt="Vizualizare Plămânul Verde al Orașului"
              className="img-fluid w-100 rounded shadow"
              style={{ objectFit: "cover", maxHeight: 800 }}
            />
          </Col>
        </Row>

        {/* Economic and Financial Analysis */}
        <Row className="justify-content-center mb-5">
          <Col lg={10}>
            <Card className="shadow rounded-4 p-4 border-0" style={{ background: "#f8fafc" }}>
              <h2 className="fw-bold mb-4 text-center" style={{ color: "#143685" }}>Analiza Economică și Financiară</h2>
              <Row>
                <Col md={6}>
                  <h5 className="fw-semibold mb-3" style={{ color: "#143685" }}>Costuri Estimate</h5>
                  <table className="table table-striped" style={{ color: "#143685" }}>
                    <thead>
                      <tr>
                        <th>Componentă</th>
                        <th>Cost Estimat (EUR)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>Amenajare spații verzi</td><td>1.000.000</td></tr>
                      <tr><td>Infrastructură și utilități</td><td>1.500.000</td></tr>
                      <tr><td>Atracții tematice (ex. roată panoramică)</td><td>2.000.000</td></tr>
                      <tr><td>Grădiniță și facilități educaționale</td><td>500.000</td></tr>
                      <tr><td>Spații comerciale și restaurante</td><td>1.000.000</td></tr>
                      <tr><th>Total</th><th>6.000.000</th></tr>
                    </tbody>
                  </table>
                </Col>
                <Col md={6}>
                  <h5 className="fw-semibold mb-3" style={{ color: "#143685" }}>Venituri Estimate</h5>
                  <table className="table table-striped" style={{ color: "#143685" }}>
                    <thead>
                      <tr>
                        <th>Sursă de Venit</th>
                        <th>Venit Anual Estimat (EUR)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>Închiriere spații comerciale</td><td>500.000</td></tr>
                      <tr><td>Taxe de acces la atracții</td><td>1.000.000</td></tr>
                      <tr><td>Evenimente și festivaluri</td><td>300.000</td></tr>
                      <tr><td>Subvenții și sponsorizări</td><td>200.000</td></tr>
                      <tr><th>Total</th><th>2.000.000</th></tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
              <div className="mt-4 text-center">
                <h5 style={{ color: "#143685" }}>Return on Investment (ROI)</h5>
                <ul style={{ listStyleType: 'none', paddingLeft: 0, fontSize: 16 }}>
                  <li>Investiție inițială: 6.000.000 EUR</li> <br/>
                  <li>Venituri anuale: 2.000.000 EUR</li> <br/>
                  <li>ROI estimat: 33% anual, cu recuperarea investiției în aproximativ 3 ani.</li>
                </ul>
              </div>
            </Card>
          </Col>
        </Row>

        {/* Sustainability and Social Impact */}
        <Row className="justify-content-center mb-5">
          <Col lg={10}>
            <Card className="shadow rounded-4 p-4 border-0" style={{ background: "#f8fafc" }}>
              <h2 className="fw-bold mb-4 text-center" style={{ color: "#143685" }}>Sustenabilitate și Impact Social</h2>
              <ul style={{ listStyleType: 'disc', paddingLeft: '1.5rem', color: '#000', fontSize: 16, textAlign: 'left' }}>
                <li><b>Mediu:</b> Reducerea emisiilor de CO₂, îmbunătățirea calității aerului și conservarea biodiversității.</li>
                <li><b>Social:</b> Crearea unui spațiu inclusiv pentru toate categoriile de vârstă, promovarea educației ecologice și sprijinirea familiilor.</li>
                <li><b>Economic:</b> Stimularea antreprenoriatului local, crearea de locuri de muncă și creșterea veniturilor fiscale.</li>
              </ul>
            </Card>
          </Col>
        </Row>

        {/* Implementation Stages */}
        <Row className="justify-content-center mb-5">
          <Col lg={10}>
            <Card className="shadow rounded-4 p-4 border-0" style={{ background: "#f8fafc" }}>
              <h2 className="fw-bold mb-4 text-center" style={{ color: "#143685" }}>Etape de Implementare</h2>
              <ol style={{ paddingLeft: '1.5rem', color: '#000', fontSize: 16, textAlign: 'left' }}>
                <li>Planificare și proiectare: Consultări publice, elaborarea planurilor și obținerea autorizațiilor.</li>
                <li>Finanțare: Accesarea fondurilor europene, naționale și atragerea de investiții private.</li>
                <li>Construcție și amenajare: Dezvoltarea infrastructurii, plantarea arborilor și instalarea atracțiilor.</li>
                <li>Operare și întreținere: Gestionarea zilnică a parcului, organizarea de evenimente și întreținerea facilităților.</li>
              </ol>
            </Card>
          </Col>
        </Row>

        {/* Success Indicators */}
        <Row className="justify-content-center mb-5">
          <Col lg={10}>
            <Card className="shadow rounded-4 p-4 border-0" style={{ background: "#f8fafc" }}>
              <h2 className="fw-bold mb-4 text-center" style={{ color: "#143685" }}>Indicatori de Succes</h2>
              <ul style={{ listStyleType: 'disc', paddingLeft: '1.5rem', color: '#000', fontSize: 16, textAlign: 'left' }}>
                <li>Număr de vizitatori anual: Peste 500.000</li>
                <li>Locuri de muncă create: Peste 300</li>
                <li>Suprafață verde nou creată: Minimum 20 hectare</li>
                <li>Reducerea emisiilor de CO₂: Cu 10% în zona urbană</li>
              </ul>
            </Card>
          </Col>
        </Row>

        {/* Conclusion */}
        <Row className="justify-content-center mb-5">
          <Col lg={10}>
            <Card className="shadow rounded-4 p-4 border-0" style={{ background: "#f8fafc" }}>
              <h2 className="fw-bold mb-3" style={{ color: "#143685" }}>Concluzie</h2>
              <p style={{ color: '#000', fontSize: 16 }}>
                „Plămânul Verde al Orașului” este un proiect ambițios care combină dezvoltarea urbană durabilă cu beneficiile sociale și economice. Prin crearea unui spațiu verde multifuncțional, proiectul va transforma orașul într-un model de sustenabilitate și inovație.
              </p>
            </Card>
          </Col>
        </Row>

       
        <ProjectDetails /> 

        {/* Footer */}
        <footer className="mt-5 mx-auto" style={{ maxWidth: 900 }}>
          <Card className="shadow rounded-4 p-4 border-0" style={{ background: "#f8fafc" }}>
            <Row className="align-items-center justify-content-between">
              <Col md="auto" className="mb-3 mb-md-0 d-flex align-items-center gap-3">
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%"
                  }}
                >
                  <img
                    src={logo}
                    alt="PRDP"
                    width={64}
                    height={64}
                    style={{
                      borderRadius: 16,
                      background: "#ffc107",
                      marginRight: 12,
                      boxShadow: "0 2px 8px #1a2c5e",
                    }}
                  />
                </div>
                <div>
                  <h5 className="fw-bold mb-1" style={{ color: "#143685" }}>PRDP</h5>
                  <div className="text-secondary small">Pentru o Românie mai curată și sustenabilă</div>
                </div>
              </Col>
              <Col md="auto" className="text-md-end text-center">
                <div className="d-flex align-items-center gap-2 text-primary mb-1 justify-content-md-end justify-content-center">
                  <Calendar size={16} color="#143685" />
                  <span className="small fw-medium" style={{ color: "#143685" }}>Mai 2025</span>
                </div>
                <div className="d-flex align-items-center gap-2 text-primary justify-content-md-end justify-content-center">
                  <User size={16} color="#143685" />
                  <span className="small fw-medium" style={{ color: "#143685" }}>Echipa PRDP</span>
                </div>
                <div className="text-secondary small mt-1">Inițiativă sustenabilă</div>
              </Col>
            </Row>
          </Card>
        </footer>
      </Container>
    </div>
  );
};

export default ProjectCard;
